export default __webpack_public_path__ + "./assets/img/reasons-4-0238cd3ea886e75dc35b290800ce0211.png";